/**
 * `RuntimeState.mapDiscovery` — what the player knows about the map beyond
 * where they have been (architecture.md §3.2).
 *
 * @remarks
 * v0 field depth: revealed-but-unvisited rooms only. Item provenance and
 * landmark knowledge join the shape when the fog-of-war map view arrives
 * (Phase 2+) — as added fields, never repurposed ones, because saves validate
 * against this schema from day one.
 *
 * @packageDocumentation
 */

import { z } from 'zod';

import { roomIdSchema } from '../identifiers.js';

/** Map knowledge beyond visited rooms — see the module remarks for v0 depth. */
export const mapDiscoveryStateSchema = z
	.strictObject({
		revealedRoomIds: z.array(roomIdSchema).readonly(),
	})
	.readonly();

/** The `mapDiscovery` sub-state — see {@link mapDiscoveryStateSchema}. */
export type MapDiscoveryState = z.infer<typeof mapDiscoveryStateSchema>;
